import { AxiosPromise } from 'axios'
import qs from 'qs'
import client from './client'

type AuthResponse = {
  detail: string
  remaining_attempts: number
  cooloff_time: number
}

export const login = (
  email: string,
  password: string
): AxiosPromise<AuthResponse> => {
  const params = qs.stringify({
    email,
    password,
  })
  return client.post('api/login/', params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export const logout = (): AxiosPromise<AuthResponse> => {
  return client.get('api/logout/')
}

export const checkAuth = async () => {
  return client.get('api/check_auth/', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export type TranscriptionMode = 'batch' | 'streaming'

export type MyPharmacyResponse = {
  id: string
  name: string
  /** 困ったときガイド・印刷用 PDF の版。back が薬局の法人から解決したもの (ADR-0051) */
  guide_variant: string
  transcription_mode: TranscriptionMode
  phrase_set_resource_name: string | null
  features: {
    is_audio_upload: boolean
  }
  /** 遠隔服薬指導 (back log/250)。頼む店なら依頼先の店名・遠隔の店なら is_remote_pharmacy */
  remote_guidance?: {
    to_pharmacy_name: string | null
    is_remote_pharmacy: boolean
  }
}

/**
 * GET /api/me/pharmacy/
 *
 * ログインユーザーの薬局運用設定を取得。`transcription_mode` で front dispatcher が
 * streaming / batch 経路を選択する。
 *
 * `check_auth/` は deprecated 扱いで、新機能フィールドはここに追加しない方針
 * (yakureki-back/log/143/design/stt_architecture.md §7.7)。
 */
export const fetchMyPharmacy = async (): Promise<MyPharmacyResponse> => {
  const response = await client.get<MyPharmacyResponse>('api/me/pharmacy/')
  return response.data
}
